

import {faXTwitter, faDiscord, faInstagram, faFacebookF } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ArenaIcon from "../icons/ArenaIconSvg";
import icon_image from "../icons/icon-image.svg";

export default function getIconForSocialNetwork(link, web_main_color, where) {
      if (link && link.includes("facebook.com")) {
        return(
          <FontAwesomeIcon icon={faFacebookF} style={where === 'preview' ? {height: '2.7rem', color: web_main_color === "" ? "#6f6f6f" : web_main_color} : {height: '4rem', color: "#6f6f6f"}} />
        );
      } else if (link && link.includes("instagram.com")) {
        return(
          <FontAwesomeIcon icon={faInstagram} style={where === 'preview' ? {height: '2.7rem', color: web_main_color === "" ? "#6f6f6f" : web_main_color} : {height: '4rem', color: "#6f6f6f"}} />
        );
      } else if (link && link.includes("x.com")) {
        return(
          <FontAwesomeIcon icon={faXTwitter} style={where === 'preview' ? {height: '2.7rem', color: web_main_color === "" ? "#6f6f6f" : web_main_color} : {height: '4rem', color: "#6f6f6f"}} />
        );
      } else if (link && link.includes("twitter.com")) {
        return(
          <FontAwesomeIcon icon={faXTwitter} style={where === 'preview' ? {height: '2.7rem', color: web_main_color === "" ? "#6f6f6f" : web_main_color} : {height: '4rem', color: "#6f6f6f"}} />
        );
      } else if (link && link.includes("discord.com")) {
        return(
          <FontAwesomeIcon icon={faDiscord} style={where === 'preview' ? {height: '2.7rem', color: web_main_color === "" ? "#6f6f6f" : web_main_color} : {height: '4rem', color: "#6f6f6f"}} />
        );
      }
      else if (link && link.includes("arena.social")) {
        return(
          <ArenaIcon 
            size="2.7rem"
            style={where === 'preview' ? {height: '2.7rem', color: web_main_color === "" ? "#6f6f6f" : web_main_color} : {height: '4rem', color: "#6f6f6f"}}
          />
        );
      }
      else {
        return(
          <img width="70" src={icon_image} alt="upload" />
        );
      }
  }